import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ID } from '@datorama/akita';
import { filter, switchMapTo, take, tap } from 'rxjs/operators';
import { Account } from './account.model';
import { AccountsStore } from './accounts.store';
import { SessionQuery } from '../../../core/state/session/session.query';
import { AppConfigQuery } from '../../../core/state/app-config/app-config.query';

/**@deprecated use AcctsService instead */
@Injectable({ providedIn: 'root' })
export class AccountsService {
    constructor(
        private accountsStore: AccountsStore,
        private http: HttpClient,
        private config: AppConfigQuery,
        private sessionQuery: SessionQuery
    ) {
        this.sessionQuery.isAuthenticated$
            .pipe(
                filter((isAuthenticated) => isAuthenticated),
                take(1),
                switchMapTo(this.get())
            )
            .subscribe();
    }

    get() {
        return this.http
            .get<Account[]>(`${this.config.get().gatewayBaseUrl}/accounts/key-value`)
            .pipe(
                tap((entities) => {
                    this.accountsStore.set(entities);
                })
            );
    }

    add(account: Account) {
        this.accountsStore.add(account);
    }

    update(id, account: Partial<Account>) {
        this.accountsStore.update(id, account);
    }

    remove(id: ID) {
        this.accountsStore.remove(id);
    }
}
